

















































import Vue, { PropType } from 'vue';
import { mapActions } from 'vuex';

import { setErrorFromAxiosError } from '@/utils/helpers';
import {
  IInventoryAdvancePayment,
  InventoryAdvancePaymentStatusEnum
} from '@/models';
import { ISystemError } from '@/models/error/error.types';

import InventoryAdvancePaymentStateTransitionCommentFormDialog from './InventoryAdvancePaymentStateTransitionCommentFormDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

interface Options extends InstanceType<typeof Vue> {
  $refs: {
    commentDialog: InstanceType<
      typeof InventoryAdvancePaymentStateTransitionCommentFormDialog
    >;
  };
}
export default Vue.extend<Options>({ functional: false }).extend({
  name: 'InventoryAdvancePaymentCancelButton',

  components: {
    ConfirmationDialog,
    InventoryAdvancePaymentStateTransitionCommentFormDialog
  },

  props: {
    inventoryAdvancePayment: {
      type: Object as PropType<IInventoryAdvancePayment>
    }
  },

  data() {
    return {
      isDialogActive: false,
      isLoading: false,
      error: null as ISystemError | null
    };
  },

  methods: {
    ...mapActions({
      updateInventoryAdvancePaymentState:
        'inventoryAdvancePayment/updateInventoryAdvancePaymentState',
      fetchInventoryAdvancePaymentActivities:
        'inventoryAdvancePayment/fetchInventoryAdvancePaymentActivities'
    }),

    async cancelInventoryAdvancePayment(): Promise<void> {
      const {
        isConfirmed,
        comment
      } = await this.$refs.commentDialog.openCommentsDialog(
        InventoryAdvancePaymentStatusEnum.Cancelled
      );
      if (isConfirmed) {
        this.clearErrors();
        this.isLoading = true;
        this.updateInventoryAdvancePaymentState({
          id: this.inventoryAdvancePayment.id,
          state: InventoryAdvancePaymentStatusEnum.Cancelled,
          comment: comment
        })
          .then(() => {
            this.fetchInventoryAdvancePaymentActivities(
              this.inventoryAdvancePayment.id
            );
          })
          .catch(error => {
            this.error = setErrorFromAxiosError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },

    clearErrors() {
      this.error = null;
    }
  }
});
